"use client";

import CategoryTag from "./CategoryTag";

export default function StatsBar({ articles }) {
  const relevant = articles.filter((a) => a.classification?.relevant).length;
  const total = articles.length;
  const catCounts = {};
  articles
    .filter((a) => a.classification?.relevant)
    .forEach((a) => {
      const c = a.classification.category;
      catCounts[c] = (catCounts[c] || 0) + 1;
    });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "14px",
        padding: "10px 16px",
        backgroundColor: "#f7f3ea",
        borderRadius: "4px",
        border: "1px solid #999",
        marginBottom: "14px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ fontSize: "12px", fontFamily: "var(--font-mono)", color: "#70706E" }}>
        <span style={{ color: "#43695B", fontWeight: 600 }}>{relevant}</span>
        <span style={{ color: "#999999" }}>/{total}</span> relevant
      </div>
      <div style={{ width: "1px", height: "16px", backgroundColor: "#DCD6C7" }} />
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
        {Object.entries(catCounts).map(([cat, count]) => (
          <div key={cat} style={{ display: "flex", alignItems: "center", gap: "3px" }}>
            <CategoryTag category={cat} small />
            <span style={{ fontSize: "11px", fontFamily: "var(--font-mono)", color: "#999999" }}>
              &times;{count}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
